// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newsBox{width:1111px;clear:both;overflow:hidden;margin:23px auto}", ""]);
// Exports
module.exports = exports;
